const GROUP = 1;
const USER = 2;
const PROVIDER = 3;
const PERSON = 5;
const OFFICE = 6;
const OFFICER = 7;
const EXTERNAL = 8;
const COMPLETION = 9;

const INTERNAL_OFFICES = 99;
const EXTERNAL_OFFICES = 98;
const CHILDREN = 97;
const USER_SEND_APPROVAL = 90;
const LEADERSHIP_SENDING_APPROVAL = 91;
const GROUP_LEADER_SENDING_APPROVAL = 92;
const USER_CREATOR_DOC = 93;
const LEADERSHIP_CREATOR_DOC = 94;
const GROUP_LEADER_CREATOR_DOC = 95;
const PERSON_FROM_DOC_PRE_DEFINED = 98;
const PERSON_FROM_DNT_PRE_DEFINED = 99;
const USER_FROM_DOC_PRE_DEFINED = 100;

export const CAN_REPEAT_TYPES = [
  PERSON_FROM_DOC_PRE_DEFINED,
  PERSON_FROM_DNT_PRE_DEFINED,
  USER_FROM_DOC_PRE_DEFINED
];

export const SHOULD_UPDATE_LABELS_TYPES = [
  PERSON_FROM_DOC_PRE_DEFINED,
  PERSON_FROM_DNT_PRE_DEFINED,
  USER_FROM_DOC_PRE_DEFINED,
  INTERNAL_OFFICES,
  EXTERNAL_OFFICES,
  CHILDREN,
  USER_SEND_APPROVAL,
  LEADERSHIP_SENDING_APPROVAL,
  GROUP_LEADER_SENDING_APPROVAL,
  USER_CREATOR_DOC,
  LEADERSHIP_CREATOR_DOC,
  GROUP_LEADER_CREATOR_DOC
];

export default {
  CAN_REPEAT_TYPES,
  SHOULD_UPDATE_LABELS_TYPES,
  GROUP,
  USER,
  OFFICE,
  OFFICER,
  INTERNAL_OFFICES,
  EXTERNAL_OFFICES,
  PROVIDER,
  COMPLETION,
  CHILDREN,
  PERSON,
  USER_SEND_APPROVAL,
  LEADERSHIP_SENDING_APPROVAL,
  GROUP_LEADER_SENDING_APPROVAL,
  USER_CREATOR_DOC,
  LEADERSHIP_CREATOR_DOC,
  GROUP_LEADER_CREATOR_DOC,
  EXTERNAL,
  PERSON_FROM_DOC_PRE_DEFINED,
  PERSON_FROM_DNT_PRE_DEFINED
};
